import { isApp } from "@/app/bridge";
import markdown from "markdown-it";
import { shouldUseWebview } from "./url";

const md = markdown({ html: true, xhtmlOut: true });

// 保留默认渲染函数
const defaultHTMLInline =
  md.renderer.rules.html_inline ||
  ((tokens, idx, options, env, self) => tokens[idx].content);
const defaultHTMLBlock =
  md.renderer.rules.html_block ||
  ((tokens, idx, options, env, self) => tokens[idx].content);

const defaultLinkOpen =
  md.renderer.rules.link_open ||
  ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

// 给单个 HTML 字符串里的 <a> 打补丁
function transformATag(html: string) {
  return html.replace(
    /<a([\s\S]*?)href="([\s\S]*?)"([\s\S]*?)>/gi,
    (match, before, href, after) => {
      // App 端且 href 包含 im 时改写 href
      const newHref =
        isApp() && !shouldUseWebview(href)
          ? `bambulab://bbl/webview?urlString=${encodeURIComponent(href)}`
          : href;
      const hasTarget = /\starget\s*=/i.test(before + after);
      const targetStr = hasTarget ? "" : ' target="_blank"';
      return `<a${before}href="${newHref}"${after}${targetStr}>`;
    },
  );
}

// 处理 markdown 语法生成的 link_open
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet("target", "_blank");
  if (isApp()) {
    const href = tokens[idx].attrGet("href");
    // 只有 href 不包含 im 相关路径时才改写为 webview 协议
    if (href && !shouldUseWebview(href)) {
      tokens[idx].attrSet(
        "href",
        `bambulab://bbl/webview?urlString=${encodeURIComponent(href)}`,
      );
    }
  }
  return defaultLinkOpen(tokens, idx, options, env, self);
};

// 处理行内 <a>（比如写在 Markdown 里的 <a>）
md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
  // 原样渲染一遍，再做替换
  const orig = defaultHTMLInline(tokens, idx, options, env, self);
  return transformATag(orig);
};

// 处理块级 <a>（独立一段的 HTML）
md.renderer.rules.html_block = (tokens, idx, options, env, self) => {
  const orig = defaultHTMLBlock(tokens, idx, options, env, self);
  return transformATag(orig);
};

export default md;
